import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "React",
    "Angular",
    "Vue",
    "three.js",
    "Node.js",
    "NestJS",
    "TypeScript",
    "JavaScript",
    "Fastify",
    "Django",
    "Flask",
    "Symfony",
    "Laravel",
    "Wordpress",
    "IONIC",
    "Flutter",
    "React Native"
];

const labelsSecond = [
    "Python",
    "R",
    "SQL",
    "Pandas",
    "NumPy",
    "Scikit-learn",
    "TensorFlow",
    "PyTorch",
    "Jupyter",
    "Matplotlib",
    "Seaborn",
    "Plotly",
    "Tableau",
    "Power BI",
    "Apache Spark",
    "Hadoop"
];

const labelsThird = [
    "OpenAI",
    "Groq",
    "LangChain",
    "Hugging Face",
    "BERT",
    "GPT",
    "Claude",
    "Transformers",
    "RAG",
    "Vector DB",
    "Embeddings",
    "Fine-tuning"
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full Stack Web/Mobile Development</h3>
                    <p>
                        As a seasoned Full Stack Developer with extensive experience, I build comprehensive web applications from scratch using modern technologies such as React/Angular/Vue and Django/Flask, Java/C#. 
                        I have strong proficiency in both frontend and backend development, creating scalable and efficient solutions.
                    </p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>Data Science & Analytics</h3>
                    <p>With advanced expertise in data science, I leverage statistical analysis, machine learning, and data visualization to extract meaningful insights from complex datasets. I specialize in building predictive models and data-driven solutions that enable informed business decisions.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>GenAI & LLM</h3>
                    <p>Stay relevant in the market by leveraging the latest AI models in your projects. I have professional experience building enterprise-grade GenAI-enabled solutions to empower intelligent decision making and automate complex processes.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;